import { render, staticRenderFns } from "./ChurchList.vue?vue&type=template&id=6bcfdd90&scoped=true&"
import script from "./ChurchList.vue?vue&type=script&lang=js&"
export * from "./ChurchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcfdd90",
  null
  
)

export default component.exports